import React, { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import Combine from './pages/Combine'
import { PATHS } from './const'
import { Modals } from './apps/Modals/components'
import './styles/global.scss'
import { useStoreon } from 'storeon/react'

const App = ({ context }: any): React.ReactElement => {
  const { dispatch } = useStoreon()

  useEffect(() => {
    dispatch('user/get', {
      callback: () => { }
    })
  }, [])

  return (
    <>
      <Helmet>
        {/* <!-- Yandex.Metrika counter --> */}
        <script type='text/javascript'>
          {`    (function(m,e,t,r,i,k,a){
        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
    })(window, document,'script','https://mc.yandex.ru/metrika/tag.js', 'ym');

    ym(97948836, 'init', {clickmap:true, accurateTrackBounce:true, trackLinks:true});`}
        </script>
        <noscript>{'<div><img src="https://mc.yandex.ru/watch/97948836" style="position:absolute; left:-9999px;" alt="" /></div>'}</noscript>
        {/* <!-- /Yandex.Metrika counter --> */}
      </Helmet>
      <Routes>
        <Route
          path={PATHS.ALL.path}
          element={<Combine staticContext={context} {...PATHS.ALL} />}
        />
      </Routes>
      <Modals />
    </>
  )
}

export default App
